import React from "react";
import { IconButton, Box, Badge } from "@mui/material";
import NotificationsIcon from "@mui/icons-material/Notifications";

const NotificationIcon = ({ onClick, unreadCount = 0 }) => {
  return (
    <Box
      sx={{
        position: "fixed",
        bottom: { xs: 16, sm: 28 },
        right: { xs: 16, sm: 28 },
        zIndex: 1200,
      }}
    >
      <IconButton
        onClick={onClick}
        sx={{
          width: { xs: 48, sm: 56 },
          height: { xs: 48, sm: 56 },
          background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
          color: "#fff",
          boxShadow: "0 6px 24px rgba(102, 126, 234, 0.5)",
          transition: "all 0.3s ease",
          "&:hover": {
            transform: "scale(1.1)",
            boxShadow: "0 8px 32px rgba(102, 126, 234, 0.6)",
            background: "linear-gradient(135deg, #5a6fd8 0%, #6a3f9e 100%)",
          },
        }}
      >
        <Badge
          badgeContent={unreadCount}
          max={99}
          overlap="circular"
          sx={{
            "& .MuiBadge-badge": {
              bgcolor: "#f5576c",
              color: "#fff",
              fontWeight: 700,
              fontSize: "0.7rem",
              minWidth: 20,
              height: 20,
              border: "2px solid #fff",
            },
          }}
        >
          <NotificationsIcon sx={{ fontSize: 26 }} />
        </Badge>
      </IconButton>
    </Box>
  );
};

export default NotificationIcon;
